export const transizionClasNamePrefix = "Madai-tr"
export const transizionTimeout = 300
export const transizionDelay = 300

export const CLOSED = 0;
export const PRE = 1;
export const OPEN = 2;
export const POST = 3;